"use client";
import React from 'react';
import { motion } from 'framer-motion';
import Link from 'next/link';

const sessionItems = [
    'Brand Positioning Review',
    'Audience & Market Analysis',
    'Competitive Landscape Assessment',
    'Messaging & Perception Audit',
    'Creative Growth Roadmap',
];

export default function BrandCTA() {
    return (
        <section
            className="relative overflow-hidden py-24 px-6 md:px-16 lg:px-24"
            style={{ background: '#ffffff', borderTopLeftRadius: '80px', borderTopRightRadius: '80px' }}
        >
            <div className="max-w-[900px] mx-auto relative z-10 text-center flex flex-col gap-10 items-center">

                <motion.span
                    initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                    className="text-xs font-bold tracking-[0.2em] uppercase"
                    style={{ color: '#3730a3', fontFamily: 'var(--font-clash), "Clash Display", sans-serif' }}
                >
                    Get In Touch
                </motion.span>

                <motion.h2
                    initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.1 }}
                    className="text-2xl md:text-4xl lg:text-5xl font-bold tracking-tight leading-tight"
                    style={{ fontFamily: 'var(--font-clash), "Clash Display", sans-serif', color: '#080400' }}
                >
                    Ready To Build A Brand<br />People Remember?
                </motion.h2>

                <motion.div
                    initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.2 }}
                    className="max-w-2xl flex flex-col gap-2 text-center"
                    style={{ fontFamily: 'var(--font-manrope), Manrope, sans-serif', fontSize: '1rem', lineHeight: '1.9', letterSpacing: '0.02em' }}
                >
                    <p style={{ color: 'rgba(8,4,0,0.65)' }}>
                        Whether you&apos;re launching something new, repositioning an existing business, or creating consistency across customer touchpoints, we&apos;ll help you build a brand designed for long-term growth.
                    </p>
                    <p style={{ color: '#3730a3', fontWeight: 600 }}>Your brand strategy session includes:</p>
                </motion.div>

                <motion.ul
                    initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.25 }}
                    className="flex flex-col gap-3 text-left w-full max-w-md"
                >
                    {sessionItems.map((item, i) => (
                        <li key={i} className="flex items-center gap-3">
                            <span
                                className="flex items-center justify-center shrink-0 rounded-full"
                                style={{ width: 24, height: 24, background: 'rgba(55,48,163,0.08)', border: '1px solid rgba(55,48,163,0.20)' }}
                            >
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                    <path d="M2 6l3 3 5-5" stroke="#3730a3" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </span>
                            <span style={{ fontFamily: 'var(--font-manrope), Manrope, sans-serif', color: 'rgba(8,4,0,0.75)', fontSize: '0.95rem' }}>
                                {item}
                            </span>
                        </li>
                    ))}
                </motion.ul>

                <motion.div
                    initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.3 }}
                    className="flex flex-col sm:flex-row gap-4 items-center"
                >
                    <Link
                        href="/contact"
                        className="inline-flex items-center justify-center px-10 py-5 rounded-full font-semibold text-lg transition-all duration-300 hover:scale-105"
                        style={{ background: '#3730a3', color: '#ffffff', fontFamily: 'var(--font-clash), "Clash Display", sans-serif', letterSpacing: '0.08em' }}
                    >
                        Book A Brand Strategy Session →
                    </Link>
                </motion.div>

                <motion.p
                    initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ delay: 0.4 }}
                    className="text-xs tracking-widest uppercase font-bold"
                    style={{ color: 'rgba(8,4,0,0.25)', fontFamily: 'var(--font-clash), "Clash Display", sans-serif' }}
                >
                    Built for visibility. Optimised for perception. Designed for growth.
                </motion.p>

            </div>
        </section>
    );
}
